import React from 'react';
import Reflux from 'reflux';

import CuesheetTrackingStore from 'flux/stores/cuesheet/CuesheetTrackingStore';
import CuesheetTrackingActions from 'flux/actions/cuesheet/CuesheetTrackingActions';
import TrackingModeToggler from 'main/components/show/cuesheet/trackingModeToggler.jsx';

/**
 * A component for listing the trackable users for a show/cuesheet, and toggling tracking
 *
 */
export default React.createClass({
  displayName: 'TrackableUserPicker',

  mixins: [Reflux.connect(CuesheetTrackingStore, 'cuesheetTracking')],

  render() {
    const state = this._getState();

    if (!state.get('trackingAvailable')) return <span />;

    return (
      <div className="cs-tracking-component">
        <TrackingModeToggler
          toggleLeftValue={state.get('trackingEnabled') === true}
          users={this._getState().get('trackableUsers')}
          activeUser={this._getState().get('selectedTrackableUser')}
          onChange={(id) => CuesheetTrackingActions.selectTrackableUser(id)}
          onToggleTrackingEnabled={() =>
            CuesheetTrackingActions.toggleTrackingEnabled()
          }
        />
      </div>
    );
  },

  _getState() {
    return this.state.cuesheetTracking;
  },
});
